import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { device } from '../../../constants/StyledComponentConstants';
export const ModalTile = styled(UITile).withConfig({
  displayName: "ModalTile",
  componentId: "jx88vv-0"
})(["border:none;border-radius:0;"]);
export const ModalTileSection = styled(UITileSection).withConfig({
  displayName: "ModalTile__ModalTileSection",
  componentId: "jx88vv-1"
})(["@media screen and ", "{padding-left:12px;padding-right:12px;}"], device.mobile);
export default ModalTile;